import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const BlogPage = () => (
  <Layout>
    <SEO title="Blog" />
    <div
          style={{
            margin: `5vw auto`,
            maxWidth: "70vw",
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0
          }}
    >
      <h2 style={{margin: "1rem auto", textAlign:"center"}}>Coming Soon</h2>

    </div>
  </Layout>
)

export default BlogPage